const updateProgress = (element1, element2, progressUnity) => {
  element1.style.width = `${(parseFloat(element1.style.width.replace(/[%]/g, "")) + progressUnity)}%`;
  element1.setAttribute("aria-valuenow", element1.style.width.replace(/[%]/g, ""));
  element2.style.width = `${(parseFloat(element2.style.width.replace(/[%]/g, "")) + progressUnity)}%`;
  element2.setAttribute("aria-valuenow", element2.style.width.replace(/[%]/g, ""));
}

export { updateProgress };
